export enum FaqStatus {
    Draft = 0,
    Active = 1,
}

export enum FaqServiceType {
    All = 0,
    DB = 1,
    FSB = 2,
    SFAS = 3,
}

export enum FaqParty {
    All = 0,
    Seller = 1,
    Buyer = 2,
}

export enum FaqAttachmentType {
    None = 0,
    Image = 1,
    Video = 2,
}

export enum FaqImagePosition {
    Right = 0,
    Top = 1,
    Bottom = 2,
    Left = 3,
}

export interface GetFaqItemDto {
    faqItemId: string;
    kbContentId: number;
    question: string;
    answer: string;
    serviceType: FaqServiceType;
    party: FaqParty;
    attachmentType: FaqAttachmentType;
    imagePosition: FaqImagePosition | null;
    attachmentUrl: string | null;
    fileName: string | null;
    status: FaqStatus;
    dateCreated: string | null;
    dateModified: string | null;
}

export interface SaveFaqItemDto {
    faqItemId?: string;
    question: string;
    answer: string;
    serviceType: FaqServiceType;
    party: FaqParty;
    attachmentType: FaqAttachmentType;
    imagePosition: FaqImagePosition | null;
    status: FaqStatus;
}
